import { z } from 'zod';

export const useStepTwoValidation = () => {
	const stepTwoSchema = z.object({
		problems: z.array(
			z.object({
				id: z.number().optional(),
				text: z.string().trim().min(1).max(200),
				now: z.string().max(2000).optional(),
				importance: z.number().min(1).max(10),
				parentSectionName: z.string().trim().min(1),
				subsection: z.object({
					sectionName: z.string().trim().min(1),
				}),
				shortTermGoals: z
					.array(
						z.object({
							id: z.number().optional(),
							goal: z.string().trim().optional(),
							resultScore: z.string().optional().nullable(),
						}),
					)
					.max(3)
					.optional(),
				stepType: z.string().optional(),
			}),
		),
	});

	return { stepTwoSchema };
};
export type StepTwoInfo = z.infer<ReturnType<typeof useStepTwoValidation>['stepTwoSchema']>;
